import React from 'react';
import { useTranslation } from '../../localization/useTranslation';
import { Modal, ModalVariant } from '@patternfly/react-core';
import { acceptButton } from '../Modals/ModalButtons';
import Icons, { Size } from '../Common/Icons';
import HelpView from './HelpView';
import useBoolean from 'utils/hooks/useBoolean';

import styles from './HelpModal.module.css';
import PropTypes from 'prop-types';

const LicenseModal = ({ isOpen, onAcceptLicense, file }) => {
  const T = useTranslation();
  const [accepted, , , toggle] = useBoolean(false);
  return (
    <div style={{ zIndex: 500 }}>
      <Modal
        variant={ModalVariant.large}
        title={T.common.licenseAgreement}
        titleIconVariant={() => <Icons.Info size={Size.MEDIUM} />}
        isOpen={isOpen}
        onClose={onAcceptLicense}
        actions={acceptButton({ T, acceptText: T.common.licenseAgreementAccept, onAccept: onAcceptLicense, accepted, toggle })}
        className={styles.modalhelp}
        showClose={false}
        onEscapePress={() => {}}
      >
        <HelpView file={file} className={styles.content}/>
      </Modal>
    </div>
  );
};

LicenseModal.propTypes = {
  isOpen: PropTypes.bool,
  onAcceptLicense: PropTypes.func,
  file: PropTypes.string.isRequired
};

export default React.memo(LicenseModal);
